"use client";

import { useRouter } from "next/navigation";
import { CrashScreen } from "@/components/error/crash-screen";
import { useClientLocale } from "@/lib/i18n/use-client-locale";

export default function LocaleError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	const locale = useClientLocale();
	const router = useRouter();

	// PR-1 (D1 "Failed query" storm, category-jobs filter 500s): `reset()`
	// alone only re-renders the error boundary's existing (still-erroring)
	// segment from the Router Cache — it does not invalidate it, so a category
	// filter page that 500'd on a transient D1 error kept re-rendering the same
	// failure and "Try Again" looked dead. `router.refresh()` first forces
	// Next.js to re-request the Server Component payload from the origin
	// (bypassing the Router Cache), THEN `reset()` clears the boundary so the
	// fresh render can actually replace the fallback UI. Scoped to this nested
	// boundary only (not `global-error.tsx`'s CrashScreen usage) — the root
	// boundary replaces the whole app and can't assume a router is mounted.
	function handleRetry() {
		router.refresh();
		reset();
	}

	return <CrashScreen locale={locale} error={error} reset={handleRetry} />;
}
